// Helpers that turn a flat list of records into the per-day buckets the dashboard charts need.
// Every list is walked once; the charts then only look up the day they are drawing.

// The last 31 days, oldest first.
export function lastDays() {
  let days = []
  for(let i = 30; i >= 0; i--) {
    days.push(new Date(new Date().getTime() - (i * 86400000)))
  }
  return days
}

export function dayLabel(date) {
  return date.toLocaleDateString("de-DE", { month: 'numeric', day: 'numeric'})
}

// Identifies the day a date belongs to. Entries are sorted into these buckets in a single pass,
// instead of scanning the whole list again for every day of the chart.
export function dayKey(date) {
  return date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate()
}

export function get(map, key) {
  return map.get(key) || 0
}

// Number of entries per day. toDate returns the date of an entry.
export function countPerDay(list, toDate) {
  let counts = new Map()
  list.forEach(entry => {
    let key = dayKey(toDate(entry))
    counts.set(key, get(counts, key) + 1)
  })
  return counts
}

// Sum of propertyKey per day.
export function sumPerDay(list, toDate, propertyKey) {
  let sums = new Map()
  list.forEach(entry => {
    let key = dayKey(toDate(entry))
    sums.set(key, get(sums, key) + entry[propertyKey])
  })
  return sums
}

// Sum of propertyKey per value of groupKey and day, as a map of maps.
export function sumPerGroupAndDay(list, toDate, groupKey, propertyKey) {
  let groups = new Map()
  list.forEach(entry => {
    let group = groups.get(entry[groupKey])
    if(group === undefined) {
      group = new Map()
      groups.set(entry[groupKey], group)
    }
    let key = dayKey(toDate(entry))
    group.set(key, get(group, key) + entry[propertyKey])
  })
  return groups
}

// Sum of propertyKey per value of groupKey.
export function sumPerGroup(list, groupKey, propertyKey) {
  let sums = new Map()
  list.forEach(entry => {
    sums.set(entry[groupKey], get(sums, entry[groupKey]) + entry[propertyKey])
  })
  return sums
}
